fragment DocumentTags on Document {
  id
  tags
}
